// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d948a3{display:inline-block}.d948a3,.d948a3 svg{vertical-align:middle}._5f3b35{width:2em}.e67251{width:5.25em}", ""]);
// Exports
exports.locals = {
	"container": "d948a3",
	"logo": "_5f3b35 d948a3",
	"text": "e67251 d948a3"
};
module.exports = exports;
